module.exports = __webpack_public_path__ + "static/media/sign-up-backgrpund.c4d8f988.png";